module.exports = __webpack_public_path__ + "img/servipag.4da20a8c.svg";